import Vue from 'vue'
import VueRouter from 'vue-router'

const router = new VueRouter({
  routes: [
    { 
      path: '/', 
      redirect: '/home',
    },
    {
      name: 'index',
      path: '/index',
      redirect: '/home',
      // meta: {
      //   index: 1
      // },
      // component: () => import('@/pages/index.vue'),
    },
    {
      name: 'home',
      path: '/home',
      meta: {
        index: 2
      },
      component: () => import('@/pages/home.vue'),  // home
    },
    {
      name: 'space',
      path: '/space',
      component: () => import('@/pages/space.vue'), // 极狐空间
    },
    {
      name: 'exhibition',
      path: '/exhibition',
      component: () => import('@/pages/exhibition.vue'), // 展台信息
    },
    {
      name: 'gift',
      path: '/gift',
      component: () => import('@/pages/gift.vue'), // 礼物
    },
    {
      name: 'introduce',
      path: '/introduce',
      component: () => import('@/pages/introduce.vue'), // 车型介绍
    },
    {
      name: 'hexiao',
      path: '/hexiao',
      component: () => import('@/pages/hexiao.vue'), // 车型介绍
    },
    // {
    //   name: 'detail',
    //   path: '/detail/:id',
    //   component: () => import('@/pages/detail.vue'), // 车型介绍详情
    // },

    {
      name: 'more',
      path: '/more',
      component: () => import('@/pages/more.vue'), // 更多
    },
  ]
})


export default router